import { useId } from 'react';

import { Switch as ShadcnSwitch } from '@/components/ui/switch';
import { Field, FieldContent, FieldDescription, FieldLabel } from '@/components/ui/field';

/**
 * COMPATIBILITY SHIM — legacy Switch API over shadcn's.
 *
 * Translates onChange -> onCheckedChange. The manual role="switch"/aria-checked
 * wiring is dropped: Radix renders both natively, and duplicating them was
 * redundant at best.
 */

export interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  label?: string;
  description?: string;
  ariaLabel?: string;
}

export function Switch({ checked, onChange, disabled, label, description, ariaLabel }: SwitchProps) {
  const id = useId();

  const toggle = (
    <ShadcnSwitch
      id={id}
      checked={checked}
      onCheckedChange={onChange}
      disabled={disabled}
      aria-label={ariaLabel}
    />
  );

  if (!label && !description) return toggle;

  return (
    <Field orientation="horizontal" data-disabled={disabled || undefined}>
      {toggle}
      <FieldContent>
        {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
        {description && <FieldDescription>{description}</FieldDescription>}
      </FieldContent>
    </Field>
  );
}
